import { render } from "./ConfidenceChangeActivityBadge.vue?vue&type=template&id=5dd78cd2&scoped=true"
import script from "./ConfidenceChangeActivityBadge.vue?vue&type=script&lang=js"
export * from "./ConfidenceChangeActivityBadge.vue?vue&type=script&lang=js"

import "./ConfidenceChangeActivityBadge.vue?vue&type=style&index=0&id=5dd78cd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5dd78cd2"

export default script